import FormatCurrency from 'components/Common/FormatCurrency'
import { formatSaleUnitLabel } from 'hooks/useSaleUnitFormatting'
import Caption from 'LuxKit/Typography/Caption'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'
import type { ComponentProps } from 'react'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  memberPrice: number
  saleUnit?: string
  className?: string
}

/**
 * Displays the LuxPlus member price as a secondary caption-sized row,
 * matching the visual weight of PriceRowLuxPlusNonMemberPrice but with
 * LuxPlus branding (teal colour + logo).
 */
function PriceRowLuxPlusMemberPrice(props: Props) {
  const intl = useIntl()
  const {
    memberPrice,
    saleUnit,
    signDisplay,
    className,
  } = props

  const saleUnitLabel = formatSaleUnitLabel(intl, saleUnit, { withLeadingSlash: true })

  const price = <b><FormatCurrency signDisplay={signDisplay} value={memberPrice} format="roundedDollar" /></b>
  const logo = <LuxPlusLogoWrapper height={8} />

  return <Caption
    variant="medium"
    colour="lux-plus"
    className={className}
    weight="normal"
  >
    {saleUnitLabel && <FormattedMessage
      id="sWbgJKcp04pBEIZkj-gl"
      defaultMessage="{price} {saleUnit} with {logo}"
      description="LuxPlus member price display format including sale unit and logo"
      values={{ price, saleUnit: saleUnitLabel, logo }}
    />}
    {!saleUnitLabel && <FormattedMessage
      id="qzB0AQvu4NZmqKJkbmty"
      defaultMessage="{price} with {logo}"
      description="LuxPlus member price display format with logo, without sale unit"
      values={{ price, logo }}
    />}
  </Caption>
}

export default PriceRowLuxPlusMemberPrice
